import React, { useContext } from 'react'
import type { Activity } from '@paintscout/api'

interface ActivityTimelineContextValue {
  activities: Activity[]
  /**
   * The document currently being viewed (deal/contact/company). A note is shown as pinned only
   * when its `details.pinnedOn` includes this id. Undefined on feeds that don't support pinning.
   * See #21136.
   */
  pinnedDocId?: string
  /**
   * True when the timeline renders without day headings, so each row must show its own date.
   * See ENG-2261.
   */
  hideHeadings?: boolean
}

export const ActivityTimelineContext = React.createContext<ActivityTimelineContextValue>({
  activities: []
})

export const useActivityTimeline = () => useContext(ActivityTimelineContext)
